import React from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { ClassificationView } from '../../common/ui/classification-view';
import { messages } from '../../messages';
const containerStyles = xcss({
  width: '330px'
});
export const ReadPopup = ({
  name,
  guideline,
  guidelineRepresentation = 'PLAIN',
  onChangeLevelClick
}) => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Box, {
    padding: "space.250",
    xcss: containerStyles,
    role: "dialog",
    "aria-labelledby": "data-classification-read-content-name",
    "aria-describedby": "data-classification-read-content-guideline",
    "aria-modal": "true"
  }, /*#__PURE__*/React.createElement(ClassificationView, {
    name: name,
    guideline: guideline,
    guidelineRepresentation: guidelineRepresentation
  }), Boolean(onChangeLevelClick) && /*#__PURE__*/React.createElement(Box, {
    paddingBlockStart: "space.200"
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "end",
    gap: "space.100"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onChangeLevelClick
  }, intl.formatMessage(messages.changeLevel)))));
};